// extracted by mini-css-extract-plugin
export default {"player":"modal-video_player__UzQJl","playerContent":"modal-video_playerContent__mwGcP"};